import EnvironmentalStatusBadge from "./EnvironmentalStatusBadge";

interface ConservationUnitTableProps {
  items: any[];
  onViewDetail: (item: any) => void;
}

export default function ConservationUnitTable({ items, onViewDetail }: ConservationUnitTableProps) {
  return (
    <div className="bg-white rounded-card border border-background-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-background-200 bg-background-50">
              <th className="text-left px-4 py-3 text-xs font-medium text-foreground-500 uppercase tracking-wider">Nome</th>
              <th className="text-left px-4 py-3 text-xs font-medium text-foreground-500 uppercase tracking-wider">Categoria</th>
              <th className="text-left px-4 py-3 text-xs font-medium text-foreground-500 uppercase tracking-wider">Grupo</th>
              <th className="text-left px-4 py-3 text-xs font-medium text-foreground-500 uppercase tracking-wider">Município/UF</th>
              <th className="text-right px-4 py-3 text-xs font-medium text-foreground-500 uppercase tracking-wider">Área (ha)</th>
              <th className="text-left px-4 py-3 text-xs font-medium text-foreground-500 uppercase tracking-wider">Instrumento Legal</th>
              <th className="text-center px-4 py-3 text-xs font-medium text-foreground-500 uppercase tracking-wider">Plano de Manejo</th>
              <th className="text-right px-4 py-3 text-xs font-medium text-foreground-500 uppercase tracking-wider">Árvores CTA</th>
              <th className="text-left px-4 py-3 text-xs font-medium text-foreground-500 uppercase tracking-wider">Status</th>
              <th className="text-center px-4 py-3 text-xs font-medium text-foreground-500 uppercase tracking-wider">Ações</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors cursor-pointer" onClick={() => onViewDetail(item)}>
                <td className="px-4 py-3">
                  <p className="text-sm font-medium text-foreground-900">{item.nome}</p>
                  <p className="text-xs text-foreground-500">{item.orgaoGestor}</p>
                </td>
                <td className="px-4 py-3"><span className="text-xs text-foreground-700 whitespace-nowrap">{item.categoria}</span></td>
                <td className="px-4 py-3"><span className="text-xs text-foreground-500 max-w-[140px] truncate block">{item.grupo}</span></td>
                <td className="px-4 py-3"><span className="text-xs text-foreground-500 whitespace-nowrap">{item.municipio}/{item.uf}</span></td>
                <td className="px-4 py-3 text-right"><span className="text-sm font-medium text-foreground-900">{item.areaHa}</span></td>
                <td className="px-4 py-3"><span className="text-xs text-foreground-500 max-w-[160px] truncate block">{item.instrumentoLegal}</span></td>
                <td className="px-4 py-3 text-center">
                  <span className={`badge ${item.temPlanoManejo ? "bg-primary-50 text-primary-700" : "bg-warning-50 text-warning-700"}`}>
                    {item.temPlanoManejo ? "Sim" : "Não"}
                  </span>
                </td>
                <td className="px-4 py-3 text-right"><span className="text-sm font-medium text-foreground-900">{item.arvoresCadastradas}</span></td>
                <td className="px-4 py-3"><EnvironmentalStatusBadge status={item.statusGestao} /></td>
                <td className="px-4 py-3">
                  <div className="flex items-center justify-center gap-1">
                    <button onClick={(e) => { e.stopPropagation(); onViewDetail(item); }} className="w-7 h-7 rounded-btn flex items-center justify-center text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer" title="Ver detalhe">
                      <i className="ri-information-line text-sm"></i>
                    </button>
                    <button onClick={(e) => e.stopPropagation()} className="w-7 h-7 rounded-btn flex items-center justify-center text-accent-600 hover:bg-accent-50 transition-colors cursor-pointer" title="Abrir mapa">
                      <i className="ri-map-pin-line text-sm"></i>
                    </button>
                    <button onClick={(e) => e.stopPropagation()} className="w-7 h-7 rounded-btn flex items-center justify-center text-foreground-500 hover:bg-background-100 transition-colors cursor-pointer" title="Documentos">
                      <i className="ri-file-text-line text-sm"></i>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}